import { RefreshCw } from "lucide-react";

import { Button } from "components/ui/Button";

import style from "./CdmLoadingSkeleton.module.css";

const SECTIONS = ["review", "tests"];
const FIELDS_PER_SECTION = 6;

// Shimmer placeholder shown while the CDM page data (PCRS scheme check, patient
// details, review status) loads. Mirrors the real layout — a header bar plus a
// large form card — so the page doesn't jump when the content swaps in. Loading
// can be slow, so an optional Refresh button lets the user re-fetch on demand.
export const CdmLoadingSkeleton = ({ onRefresh, isRefreshing = false }) => (
  <div
    className={style.wrapper}
    role="status"
    aria-busy="true"
    aria-live="polite"
  >
    <span className={style.srOnly}>Loading patient CDM data…</span>

    <div className={`${style.card} ${style.headerCard}`}>
      <div className={style.headerText}>
        <div className={`${style.shimmer} ${style.line} ${style.lineTitle}`} />
        <div
          className={`${style.shimmer} ${style.line} ${style.lineSubtitle}`}
        />
      </div>
      {!!onRefresh && (
        <div className={style.actions}>
          <Button
            variant="outline"
            startIcon={RefreshCw}
            onClick={onRefresh}
            disabled={isRefreshing}
          >
            {isRefreshing ? "Refreshing…" : "Refresh"}
          </Button>
        </div>
      )}
    </div>

    <div className={`${style.card} ${style.bigCard}`}>
      {SECTIONS.map((section) => (
        <div className={style.section} key={section}>
          <div
            className={`${style.shimmer} ${style.line} ${style.sectionTitle}`}
          />
          <div className={style.grid}>
            {Array.from({ length: FIELDS_PER_SECTION }).map((_, index) => (
              <div className={style.field} key={`${section}-${index}`}>
                <div
                  className={`${style.shimmer} ${style.line} ${style.fieldLabel}`}
                />
                <div className={`${style.shimmer} ${style.fieldInput}`} />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>
);
